import React from 'react';
import { AccountSettingsTypes } from '../../AccountSettingsTypes';
import { Icon } from '../../../../utilities/icomoon-css';

export const GateAccessCode = ({
  gateAccessCode,
  isEsignPending,
}: AccountSettingsTypes.TGateAccessCode) => {
  const RenderGateAccessSection = () => {
    if (gateAccessCode?.status === 'Unlocked') {
      return (
        <>
          <div className="labelSection">
            <p>Your Access Code</p>
          </div>
          <p>{gateAccessCode?.code}</p>
        </>
      );
    } else {
      return (
        <div className="labelSection">
          <p>Your Gate has locked out, please pay the due amount</p>
        </div>
      );
    }
  };

  const EsignEnabledLabel = () => {
    if (isEsignPending) {
      return (
        <div className="labelSection">
          <p>Esign pending, please complete the e-sign.</p>
        </div>
      );
    } else {
      return <RenderGateAccessSection />;
    }
  };

  return (
    <div className="gateAccessSection">
      <div className="gateIconPosition">
        <Icon name="tfw-lock-3-bold-cp" />
      </div>
      <div className="accessCodeContentSection">
        {gateAccessCode && Object.keys(gateAccessCode).length !== 0 ? (
          <EsignEnabledLabel />
        ) : (
          <div className="labelSection">
            <p>Access Code not Available , please contact the facility.</p>
          </div>
        )}
      </div>
    </div>
  );
};
